const { Component, DOMUtils, Utils } = window.Liftoff;

Component.register(
  "simple-text",
  class SimpleText extends Component {
    constructor(config) {
      super(config);

      Utils.assignWithDefaults(
        this,
        {
          text: null,
          maxLines: null,
        },
        this.config
      );
    }

    layout(parentNode) {
      super.layout(parentNode);

      DOMUtils.empty(this.parentNode);
      const el = document.createElement("div");
      el.classList.add("simple-text");
      el.innerHTML = this.text;
      this.parentNode.appendChild(el);

      if (Utils.type(this.maxLines) === "number" && this.maxLines >= 1) {
        let [_, fontSize] = /(.+)px/.exec(
          DOMUtils.getCSSProperty(el, "font-size")
        );
        if (!fontSize) {
          this.error("Can't apply max lines, font-size not in px units");
          return;
        }

        fontSize = Number(fontSize);
        if (this.maxLines === 1) {
          el.style.whiteSpace = "nowrap";
          const parentWidth = this.parentNode.clientWidth;
          while (el.scrollWidth > parentWidth && fontSize > 0) {
            el.style.fontSize = `${(fontSize -= 1)}px`;
          }
        } else {
          const html = el.innerHTML;
          const height = el.scrollHeight;
          el.innerHTML = `${html}<br><br>`;
          const maxHeight = (el.scrollHeight - height) * this.maxLines;
          el.innerHTML = html;
          while (el.scrollHeight > maxHeight && fontSize > 0) {
            el.style.fontSize = `${(fontSize -= 1)}px`;
          }
        }
      }
    }

    load() {}

    resize() {}

    start() {}

    stop() {}

    restart() {}
  }
);



// WEBPACK FOOTER //
// ./components/simple-text/simple-text.js